<template>
    <div class="first-payment has-fixed-submit">
      <h3 class="wt-bold font-md mb-6 lh-tight">
        Congratulation on your first request!
      </h3>

      <div>
          <p> Thank you for joining us and completing the first part of your profile.</p> <br>
          <h3><strong>Next Step - Set your payment details</strong></h3>

        <p>Before you get to accept this listing - we need to confirm your details and make sure we
            can pay you. We use Stripe as our secure payment gateway. You’ll need to set up a Stripe account, and to do
            so
            you’ll be redirected to the Stripe site. Once you’re all set up, you’ll be redirected back to us to start
            listing!</p> <br>

        <h3><strong>What is Stripe?</strong></h3>
        <p> Stripe is an online credit card provider that has been audited by a PCI-certified auditor and is certified
            to
            PCI Service Provider Level 1. We accept credit card payments through Stripe for all bookings. When a booking
            is
            confirmed for your listing, we will send you a quote to accept and payment will be sent to you online via
            Stripe, prior to the use of your space.</p> <br>
        <h3><strong>Final Step</strong></h3>
        <p> Listing your amazing space!</p>

    </div>

    <div class="mt-6  ">
      <div class="action submit">
            <span
            v-if="$store.getters['user/account'] && !$store.getters['user/stripeConnectIsOnboarded']"
            class="button primary interactive "
            @click="connectOnboardGo"
            >
            <svg-icon id="stripe" v-if="loading == false"></svg-icon>
                    <svg-icon
                        id="loading"
                        class="spin"
                        v-if="loading == true"
                    ></svg-icon
                    ><span>Connect Stripe</span>
            </span>
        </div>
      </div>
    
    </div>
  </template>
  
  <script>
  import BaseModal from '../Base'
  
  export default {
    extends: BaseModal,
    props: {
      data: {
        type: Object,
        required: false
      }
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
    connectOnboardGo() {
      this.loading = true;
      axios
        .get("/api/account/stripe-connect/account/onboard", {
          params: {
            redirect_to: this.redirectTo,
          },
        })
        .then((response) => {
          if (response.data.url) {
            return (window.location.href = response.data.url);
          }
          throw new Error("Invalid onboard link response");
        })
        .catch(() => {
          this.$toasted.show("Could not fetch Stripe connect onboard link", {
            type: "error",
          });
          this.loading = false;
        });
    },
    }
  }
  </script>
  